import logoBrahmos  from '../assets/miltech logo/BrahMos_Aerospace.svg.png';
import logoFLSmidth from '../assets/miltech logo/FLSmidth.png';
import logoIGCAR    from '../assets/miltech logo/Indira_Gandhi_Centre_for_Atomic_Research_Logo.png';
import logoLT       from '../assets/miltech logo/L&T (DEFENCE, ECC, Rubber Processing Machinery), Chennai..png';
import logoLPSC     from '../assets/miltech logo/Liquid_Propulsion_Systems_Centre_Logo.png';
import logoVSSC     from '../assets/miltech logo/VIKRAM SARABHAI SPACE RESEARCH CENTRE, Thiruvananthapuram. logo.png';

export const reviews = [
  {
    id: 1,
    name: 'Dr. K. Sivan',
    designation: 'Project Director',
    company: 'ISRO – VSSC',
    logo: logoVSSC,
    rating: 5,
    review:
      "MILLTECH CNC has consistently delivered precision aerospace components within critical timelines. Their large-bed machining capability is unmatched in the region. The CEOS Adaptor for Gaganyaan was manufactured to exact specifications.",
  },
  {
    id: 2,
    name: 'Col. R. Sharma',
    designation: 'Programme Manager',
    company: 'BrahMos Aerospace',
    logo: logoBrahmos,
    rating: 5,
    review:
      "Working with MILLTECH on defence-grade components has been an outstanding experience. Their ISO-certified processes and 25+ years of expertise ensure zero-defect delivery on sensitive programmes like K-4.",
  },
  {
    id: 3,
    name: 'Mr. Anand Krishnan',
    designation: 'Senior Engineer',
    company: 'L&T Defence, Chennai',
    logo: logoLT,
    rating: 5,
    review:
      "MILLTECH's 8.2m BERTHIEZ VTL is a game-changer. We've had complex 4-metre ring structures machined with 0.02mm accuracy, which would be impossible at most domestic vendors. Highly recommended for heavy engineering work.",
  },
  {
    id: 4,
    name: 'Dr. P. Ramasamy',
    designation: 'Head, Engineering Division',
    company: 'IGCAR – Kalpakkam',
    logo: logoIGCAR,
    rating: 5,
    review:
      "Precision and safety are non-negotiable in atomic energy applications. MILLTECH CNC's machining quality and quality assurance systems meet our stringent requirements perfectly. A trusted partner for critical components.",
  },
  {
    id: 5,
    name: 'Mr. Lars Nielsen',
    designation: 'VP Operations',
    company: 'FLSmidth, Chennai',
    logo: logoFLSmidth,
    rating: 4,
    review:
      "MILLTECH's 12.5m KOLB Gantry Boring Machine was exactly what we needed for our cement equipment structures. On-time delivery, ISO documentation, and competitive pricing make them our go-to machining partner.",
  },
  {
    id: 6,
    name: 'Mr. S. Venkatesan',
    designation: 'Chief Engineer',
    company: 'LPSC – ISRO',
    logo: logoLPSC,
    rating: 5,
    review:
      "The NADIR and CSAT assembly fixtures from MILLTECH were critical to our satellite integration programme. Quality, accuracy, and traceability were maintained throughout. We continue to place repeat orders with full confidence.",
  },
];